// The month: six rows of seven days, each cell listing its meetings in time order.
//
// It draws whole weeks, so the first and last rows reach into the neighbouring months.
// Those days are dimmed but NOT empty — the window fetched covers them (calendarDates
// rangeFor), because a cell that silently hid a real meeting would be worse than one that
// showed a day belonging to another month.
//
// A cell shows three meetings and then "עוד N". Clicking the cell opens that day in the
// day view rather than expanding in place: the day view is the thing that can show a busy
// day properly, and it already exists.
import he from '../../i18n/he';
import { todayStr } from '../../utils/dates';
import { monthWeeks } from './calendarDates';
import MeetingChip from './MeetingChip';

const SHOWN_PER_CELL = 3;

export default function MonthGrid({ anchor, byDay, partners, onOpen, onOpenDay }) {
  const weeks = monthWeeks(anchor);
  const today = todayStr();
  const month = anchor.slice(0, 7);

  return (
    <div className="month-grid">
      <div className="month-head">
        {he.calendar.weekdaysShort.map((d, i) => (
          // The short day names are a fixed, ordered list; there is no other key.
          // eslint-disable-next-line react/no-array-index-key
          <div key={i} className="month-head-cell">{d}</div>
        ))}
      </div>

      {weeks.map((week) => (
        <div key={week[0]} className="month-week">
          {week.map((day) => {
            const meetings = byDay.get(day) || [];
            const shown = meetings.slice(0, SHOWN_PER_CELL);
            const hidden = meetings.length - shown.length;
            const cls = [
              'month-cell',
              day.slice(0, 7) === month ? '' : 'outside',
              day === today ? 'today' : '',
            ].filter(Boolean).join(' ');

            return (
              <div key={day} className={cls}>
                <button type="button" className="month-day-number" onClick={() => onOpenDay(day)}>
                  {Number(day.slice(8, 10))}
                </button>
                <div className="month-cell-meetings">
                  {shown.map((m) => (
                    <MeetingChip key={m.id} meeting={m} partners={partners} onClick={onOpen} compact />
                  ))}
                  {hidden > 0 && (
                    <button type="button" className="month-more" onClick={() => onOpenDay(day)}>
                      {he.calendar.more(hidden)}
                    </button>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
}
